// extracted by mini-css-extract-plugin
export default {"root":"r34adV","image":"cerhOL","svg":"wkcQ4V"};